import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import PanelWrapper from "../../internal/panelWrapper/PanelWrapper";
import { resolveRichText } from "../../../utils/richText";
import * as styles from "./ColumnsPanel.module.scss";
import { GeneralSizeKeyToPaddingNumber  } from "../../../utils/datasources"
import ClickableImage from "../../internal/clickableImage/ClickableImage";
import ModalHelper from "../../../utils/modalHelper";

const ColumnsPanelTwoColumnImageButtons = ({ blok }) => {
  const { 
    column_1_content,
    column_2_content,
    column_1_image,
    column_2_image,
    column_1_image_click_link,
    column_2_image_click_link,
    column_1_image_is_modal,
    column_2_image_is_modal,
    column_1_modal_id,
    column_2_modal_id,
    column_1_modal,
    column_2_modal,
  } = blok ? blok : [];
  const headerPaddingTop = GeneralSizeKeyToPaddingNumber(blok.header_padding_top),
        headerPaddingBot = GeneralSizeKeyToPaddingNumber(blok.header_padding_bottom),
        footerPaddingTop = GeneralSizeKeyToPaddingNumber(blok.footer_padding_top),
        footerPaddingBot = GeneralSizeKeyToPaddingNumber(blok.footer_padding_bottom)
  return (
    <PanelWrapper blok={blok}>
      {blok.show_header ? (
        <div className={styles.header_span} style={{paddingTop: headerPaddingTop, paddingBottom: headerPaddingBot}}>
          <div
            dangerouslySetInnerHTML={resolveRichText(blok.header_text)}
          ></div>
        </div>
      ) : null}
      <Container className={styles.ThreeColImageButtonContainer}>
        <Row className={styles.rowContainer}>
          <Col xs={12} sm={6} className={styles.colContainer}>
            {column_1_modal ? <ModalHelper buttonProps={{component: "click_image", modal: column_1_modal, image: column_1_image}}/> :<ClickableImage image={column_1_image} imageLink={column_1_image_click_link} isModal={column_1_image_is_modal} modalId={column_1_modal_id} modal={column_1_modal} />}
            {/* {column_1_modal ? <ModalHelper buttonProps={{cta_type: "click_image", modal: column_1_modal, image: column_1_image}}/> :<ClickableImage image={column_1_image} imageLink={column_1_image_click_link} isModal={column_1_image_is_modal} modalId={column_1_modal_id} modal={column_1_modal} />} */}
            {/* <ClickableImage image={column_1_image} imageLink={column_1_image_click_link} isModal={column_1_image_is_modal} modalId={column_1_modal_id} modal={column_1_modal} /> */}
            <div className={styles.imageButtonContent} dangerouslySetInnerHTML={resolveRichText(column_1_content)}></div>
          </Col>
          <Col xs={12} sm={6} className={styles.colContainer}>
            {column_2_modal ? <ModalHelper buttonProps={{component: "click_image", modal: column_2_modal, image: column_2_image}}/> :<ClickableImage image={column_2_image} imageLink={column_2_image_click_link} isModal={column_2_image_is_modal} modalId={column_2_modal_id} modal={column_2_modal} />}
            {/* {column_2_modal ? <ModalHelper buttonProps={{cta_type: "click_image", modal: column_2_modal, image: column_2_image}}/> :<ClickableImage image={column_2_image} imageLink={column_2_image_click_link} isModal={column_2_image_is_modal} modalId={column_2_modal_id} modal={column_2_modal} />} */}
            {/* <ClickableImage image={column_2_image} imageLink={column_2_image_click_link} isModal={column_2_image_is_modal} modalId={column_2_modal_id} modal={column_2_modal}/> */}
            <div className={styles.imageButtonContent} dangerouslySetInnerHTML={resolveRichText(column_2_content)}></div>
          </Col>
        </Row>
      </Container>

      {blok.show_footer ? (
        <div className={styles.footer_span} style={{paddingTop: footerPaddingTop, paddingBottom: footerPaddingBot}}>
          <div
            dangerouslySetInnerHTML={resolveRichText(blok.footer_text)}
          ></div>
        </div>
      ) : null}
    </PanelWrapper>
  );
};

export default ColumnsPanelTwoColumnImageButtons;
